import { useContext } from 'react';

import { apiObject } from 'rudder-sdk-js';

import { AnalyticsContext } from './AnalyticsContext';
import { EventProperties, EventSource } from './EventProperties';
import { EVENTS } from './Events';
import { UserTraits } from './UserTraits';

/**
 * Wrapped, typed Rudderstack functions.
 * Need to optional chain since Rudderstack may not be initialized yet.
 */

// user ID + any relevant user traits: https://www.rudderstack.com/docs/rudderstack-api/api-specification/rudderstack-spec/identify/
export function useIdentify() {
  const { isLoading, rudder } = useContext(AnalyticsContext);

  return (userTraits?: Partial<UserTraits>, userId?: string) => {
    if (!isLoading && rudder) {
      try {
        rudder.identify(userId, userTraits);
      } catch (e) {
        console.log(e);
      }
    }
  };
}

// event name + any relevant attributes: https://www.rudderstack.com/docs/rudderstack-api/api-specification/rudderstack-spec/track/
export function useTrack() {
  const { isLoading, rudder } = useContext(AnalyticsContext);

  return <T extends EVENTS>(eventName: T, eventProperties: Partial<EventProperties[T]>) => {
    if (!isLoading && rudder) {
      try {
        rudder.track(eventName, { ...eventProperties, client: EventSource.WEB } as apiObject);
      } catch (e) {
        console.log(e);
      }
    }
  };
}
